import React from 'react';
import { IOldIconProps } from './type';

const Refresh: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.772 13.94a.59.59 0 00.81-.549.598.598 0 00-.172-.42l-.885-.886h2.373a3.915 3.915 0 012.57 6.882.59.59 0 00.396 1.027.59.59 0 00.382-.145 5.101 5.101 0 00-3.348-8.95h-2.37l.891-.885a.594.594 0 00-.84-.84l-1.898 1.898a.602.602 0 00-.173.42.593.593 0 00.173.42l1.898 1.899c.055.055.121.098.193.128zm-1.67 7.162h2.368l-.89.886a.598.598 0 00.192.968.59.59 0 00.227.045.59.59 0 00.43-.174l1.898-1.898a.598.598 0 000-.84l-1.898-1.898a.594.594 0 00-.84.84l.885.885H14.1a3.915 3.915 0 01-2.57-6.87.594.594 0 10-.778-.894 5.102 5.102 0 003.348 8.95z"
        fill={color}
      />
    </svg>
  );
};

export default Refresh;
